import { render, staticRenderFns } from "./vGenericConfirmationModal.vue?vue&type=template&id=22b1a03c&scoped=true"
import script from "./vGenericConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./vGenericConfirmationModal.vue?vue&type=script&lang=ts"
import style0 from "./vGenericConfirmationModal.vue?vue&type=style&index=0&id=22b1a03c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b1a03c",
  null
  
)

export default component.exports